$('.fade').slick({
  dots: true,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 2000,
});
$('.fade2').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    appendDots: $('.appenddots'),
});

var activeClass = 'slick-active', ariaAttribute = 'aria-hidden';
$( '.fade2' ) .on( 'init', function() {
    $( '.slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
})
.on( 'afterChange', function( event, slick, currentSlide ) {
    var $dots = $( '.slick-dots' );
    $( 'li', $dots ).removeClass( activeClass ).attr( ariaAttribute, true );
    $dots.each( function() {
        $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
    });
});

$(function(){
  $('#create_customer').submit(function(e) {     
    if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
      e.preventDefault();
      alert('Passwords do not match.');
    }
  });
});

function changeQty(delta) {
  const input = document.getElementById("quantity");
  let value = parseInt(input.value) || 0;
  const min = parseInt(input.min) || 0;
  value = Math.max(min, value + delta);
  input.value = value;
}

// Product Page Input
document.querySelectorAll('.qty-btn').forEach(button => {
  button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input[type="number"]');
    const min = parseInt(input.min) || 1;
    let value = parseInt(input.value) || min;

    if (button.classList.contains('plus')) {
      input.value = value + 1;
    } else if (button.classList.contains('minus') && value > min) {
      input.value = value - 1;
    }
  });
});


// Hide Get offer Section on Scroll
document.addEventListener('DOMContentLoaded', function() {
  const bar = document.querySelector('.header-discount-announcement-bar.promotion-save');

  if (!bar) return; // safety

  window.addEventListener('scroll', function() {
    if (window.scrollY > 50) {
      bar.classList.add('hide-bar'); // hide when scrolled down
    } else {
      bar.classList.remove('hide-bar'); // show when at the very top
    }
  });
});


// Featured Collection On Mobile Slider
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768) {
    const slider = $('#Slider-template--17270821716166__hurry_featured_collection_BC3fTj');
    
    // Remove any script tags before slick init
    slider.find('script').remove();

    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 2000,
      mobileFirst: true
    });
  }
});

// Our Most Popular
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768) {
    const slider = $('#Slider-template--17270821716166__featured_collection_2_8fYPrz');
    
    // Remove any script tags before slick init
    slider.find('script').remove();

    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 2000,
      mobileFirst: true
    });
  }
});

// Hide Filter onclick on Button
document.addEventListener('DOMContentLoaded', function() {
  const filterSection = document.querySelector('.filter-section-hide');
  const filterButton = document.querySelector('.filter-collection-page');

  if (!filterSection || !filterButton) return;

  // On load — restore state from localStorage
  if (window.innerWidth <= 768) {
    const savedState = localStorage.getItem('filterSectionState');
    if (savedState === 'open') {
      filterSection.classList.add('active');
    } else {
      filterSection.classList.remove('active');
    }
  }

  // On click — toggle state and save it
  filterButton.addEventListener('click', function(e) {
    if (window.innerWidth <= 768) {
      e.preventDefault(); // stop instant reload
      filterSection.classList.toggle('active');

      // Save state
      if (filterSection.classList.contains('active')) {
        localStorage.setItem('filterSectionState', 'open');
      } else {
        localStorage.setItem('filterSectionState', 'closed');
      }
    }
  });
});




// put at bottom of page or inside DOMContentLoaded
document.querySelectorAll('.input-field-card-detail-d input[type="number"]').forEach(function(el) {
  // prevent wheel from changing value
  el.addEventListener('wheel', function(e) { e.preventDefault(); }, { passive: false });

  // prevent arrow keys from incrementing
  el.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
  });
});



// Lable Height Jquery
$(document).ready(function () {
  function setDynamicEqualHeight(selector, useMin = false) {
    let $els = $(selector);
    if (!$els.length) return;

    // Reset before measuring
    $els.css(useMin ? 'min-height' : 'height', 'auto');

    // Find tallest
    let maxHeight = 0;
    $els.each(function () {
      let h = $(this).outerHeight();
      if (h > maxHeight) maxHeight = h;
    });

    // Apply
    $els.css(useMin ? 'min-height' : 'height', maxHeight + 'px');
  }

  const selectors = [
    '.home-page .selling_products ul li .card__content h4',
    '.product-page .selling_products .card__content .card__information h3 a',
    '.product-page h3.product-title',
    '.recently-viewed-products .grid__item h4.product-description'
  ];

  function equalizeAll() {
    selectors.forEach(sel => setDynamicEqualHeight(sel));
  }

  // Run after DOM + images/fonts load
  $(window).on('load', equalizeAll);
  $(window).on('resize', function () {
    clearTimeout(window.__resizeTimer);
    window.__resizeTimer = setTimeout(equalizeAll, 150);
  });
});

$(document).ready(function () {
  // Apply to all number inputs inside .input-field-card-detail-d
  $('.input-field-card-detail-d input[type="number"]').on('input', function () {
    // Remove anything that's not a digit
    this.value = this.value.replace(/[^0-9]/g, '');
  });

  // Also prevent typing letters directly
  $('.input-field-card-detail-d input[type="number"]').on('keypress', function (e) {
    // Allow: backspace, delete, arrows, tab
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  });
});
